import { ButtonEmpty } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { isSsoDisabled } from '../../selectors/selectors'

export default function ClubOneSsoLoginLink() {
  const { t } = useTranslation()
  const disabled = useSelector(isSsoDisabled)

  return (
    <ButtonEmpty disabled={disabled} onClick={() => window.SSO.open()}>
      {t('clubOne.loginLink').toUpperCase()} →
    </ButtonEmpty>
  )
}
